'use client';

import { CardVariants, ConfigUrlData } from '@/app/lib/schemas/types/shared';
import { configPathToSolutionPage } from '@/app/lib/utils/helpers';
import { useAppSelector } from '@/app/lib/store/hooks';
import { useEffect, useMemo, useState } from 'react';
import CardFooterView from './card-footer-view';
import { usePathname } from 'next/navigation';
import { InvalidDataError } from '@/app/lib/errors/shared';

interface Props {
  markdown: string;
  variant: CardVariants;
  configUrlData: ConfigUrlData;
}

const CardFooterContainer = ({ markdown, configUrlData, variant }: Props) => {
  const pathname = usePathname();
  const { topicSlug } = configUrlData;
  const branches = useAppSelector(state => state.navigation.branches);

  const [showAnswer, setShowAnswer] = useState(false);

  const scrollPosition = useAppSelector(state => state.scroll.scrollTop);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const solutionUrl = useMemo(() => {
    if (!isClient) return '';

    let baseUrl;
    switch (variant) {
      case 'latest':
      case 'top-rated': {
        const branchSlug = branches.find(branch =>
          branch.topics.find(topic => topic.slug === topicSlug)
        )?.slug;

        if (!branchSlug)
          throw new InvalidDataError('Не удалось сконфигурировать url');

        baseUrl = `/${branchSlug}/${topicSlug}`;
        break;
      }
      case 'default':
        baseUrl = pathname;
        break;
      default:
        throw new InvalidDataError('Вариант компонента не поддерживается');
    }

    return configPathToSolutionPage(baseUrl, configUrlData);
  }, [isClient, branches, topicSlug, configUrlData, pathname, variant]);

  const handleShowSolution = () => {
    sessionStorage.setItem('scrollPosition', String(scrollPosition));
    sessionStorage.setItem('prevPage', window.location.pathname);
  };

  if (!isClient) return null;

  return (
    <CardFooterView
      markdown={markdown}
      showAnswer={showAnswer}
      onToggleAnswer={() => setShowAnswer(prev => !prev)}
      solutionUrl={solutionUrl}
      onBeforeNavigateToSolution={handleShowSolution}
    />
  );
};

export default CardFooterContainer;
